module.exports = __webpack_public_path__ + "img/moneta_logo_dark.6412d471.svg";